import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container d-flex align-items-center justify-content-center custom-background-height py-5" }
const _hoisted_2 = { class: "col-12 col-sm-10 col-md-7 col-lg-6 col-xl-4 shadow rounded-4 p-4 bg-pink" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-primary fw-normal mb-4" }, "Check your e-mail", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-4 shadow p-3 border border-4 border-primary border-top-0 border-bottom-0 border-end-0 lh-1" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-primary" }, " Check your email! You will receive an email message with instructions on how to reset your password, then visit the Sign In page. ")
], -1)
const _hoisted_5 = { class: "my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "btn bg-light shadow mb-2 rounded-pill w-100 text-decoration-none text-primary border border-1 border-primary border-opacity-50",
            to: { name: 'SignIn' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign In! ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}